// extracted by mini-css-extract-plugin
export default {"Container":"UpdatedBy-module__Container--u2Drl","UserLink":"UpdatedBy-module__UserLink--zN08W","GitHubAvatar":"UpdatedBy-module__GitHubAvatar--FWa7S"};